import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaSelectDropDown'

type IcaSelectDropDownProps = React.JSX.IntrinsicElements['tgdb-ica-select-drop-down']

export const IcaSelectDropDown = wrapWc<IcaSelectDropDownProps>('tgdb-ica-select-drop-down', [])